import gql from 'graphql-tag';

const getCardCategoryCardGroupsQuery = gql`
  query getCardCategoryCardGroupsQuery(
    $card_category_id: RecordID
    $root_only: Boolean = true
  ) {
    cardCategories(
      slice: { offset: 0, limit: 1 }
      card_category_id: $card_category_id
      root_only: $root_only
    ) {
      total
      records {
        id
        name
        is_active
        asset_image {
          id
          url
        }
        card_groups {
          total
          records {
            id
            name
          }
        }
      }
    }
  }
`;

export default getCardCategoryCardGroupsQuery;
